import { createCsvValidator, type CsvValidator, type ValidationResult } from '~/components/general/createCsvValidator';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const MAX_FILE_SIZE_BYTES = 1000 * 1000 * 1000;

function validate(file: File): Promise<ValidationResult> {
    const { onCorporate } = useCurrentGroup();

    return createCsvValidator({
        maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
        requiredHeadings: ['phone'],
        optionalHeadings: ['first_name', 'last_name', 'email', 'time_zone', 'marketing', 'transactional'],
        validateHeading: (heading: string) => {
            if (!onCorporate() && ['marketing', 'transactional'].includes(heading.trim().toLowerCase())) {
                return `The field ${heading} could not be mapped, please refer to the example template and follow format as is in it, including case-folding.`;
            }
            return undefined;
        },
    }).validate(file);
}

export const contactCsvValidator: CsvValidator = {
    validate,
    maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
};

export { validate as validateCsvFile };
